export default __webpack_public_path__ + "static/media/38.634eb60d.jpg";